import moment from "moment"
import { MatchStatus } from "./models"
import store from "../store"

export function relativeTime(date) {
  return moment(date).fromNow()
}

export function shortDate(date) {
  return moment(date).format("ll")
}

/**
 * Shorten the text to desired length, adding ellipses if necessary
 * @param {input text} text
 * @param {max # of chars to show} maxChars
 */
export function truncate(text, maxChars) {
  if (text && text.length > maxChars && maxChars > 0) return text.slice(0, maxChars) + "…"
  return text
}

// TODO: Move this to config
const CLIENT_ID = "GOOGLE"
const PROJECT_ID = "quickTourney"

export function isValidClient(clientId) {
  return clientId === CLIENT_ID
}
export function isValidRedirectURI(url) {
  return url && url.match(`https://oauth-redirect.googleusercontent.com/r/${PROJECT_ID}`)
}

//#region Location
export class LocationTools {
  static isMine(location) {
    if (store.state.currentUser) return store.state.currentUser.user.id === location.userId
    return false
  }
}
//#endregion

//#region Tournament
export class Sport {
  constructor(name, icon) {
    this.name = name
    this.icon = icon
  }
}

export const Sports = [
  new Sport("Badminton", "/static/img/sports/icons8-shuttercock-50.png"),
  new Sport("Tennis", "/static/img/sports/icons8-tennis-player-50.png"),
  new Sport("Table Tennis", "/static/img/sports/icons8-ping-pong-50.png"),
  new Sport("Volleyball", "/static/img/sports/icons8-volleyball-player-50.png"),
  new Sport("Other", "")
]

export class TournamentTools {
  static isMine(tournament) {
    if (store.state.currentUser) return store.state.currentUser.user.id === tournament.userId
    return false
  }
  static icon(tournament) {
    const sport = Sports.find(x => x.name === tournament.sport)
    return sport && sport.icon
  }
}
//#endregion

//#region Matches
const BYE_NAME = "BYE"
export const NA_VENUE = "N/A"

export class MatchTools {
  /**
   * A match is deemed ready if both competitors are set, it hasn't started or ended and neither competitor is currently
   * in a match that is in-progress.
   *
   * @static
   * @param {*} match
   * @returns
   * @memberof MatchTools
   */
  static isReady(tournament, match) {
    if (match.status === MatchStatus.Ready) {
      return !MatchTools.isPlaying(tournament, match.firstCompetitor, match.secondCompetitor)
    }
    return false
  }
  static isInProgress(match) {
    return match.status === MatchStatus.InProgress
  }
  static isCompleted(match) {
    return match.status === MatchStatus.Completed
  }
  static isPending(tournament, match) {
    if (match.status === MatchStatus.Ready) {
      return MatchTools.isPlaying(tournament, match.firstCompetitor, match.secondCompetitor)
    }
    return match.status === MatchStatus.NotReady
  }
  static isPlaying(tournament, ...competitors) {
    return tournament.matches.some(
      x =>
        x.status === MatchStatus.InProgress &&
        ((x.firstCompetitor && competitors.some(y => y.id === x.firstCompetitor.id)) ||
          (x.secondCompetitor && competitors.some(y => y.id === x.secondCompetitor.id)))
    )
  }
  static competitorsDescription(match) {
    if (MatchTools.isCompleted(match)) {
      if (match.loser.name === BYE_NAME) return `${match.winner.name} had a bye`
      return `${MatchTools.competitorName(match.winner)} def ${MatchTools.competitorName(match.loser)}`
    }
    return `${MatchTools.competitorName(match.firstCompetitor)} vs ${MatchTools.competitorName(
      match.secondCompetitor
    )}`
  }
  static competitorName(competitor) {
    return (competitor && competitor.name) || "________"
  }
  static extraInfo(tournament, match) {
    const extraInfo = []
    if (MatchTools.isCompleted(match)) {
      extraInfo.push(`${match.score.notes || "No score"}`)
      extraInfo.push(`Ended ${relativeTime(match.endTime)}`)
    } else if (MatchTools.isInProgress(match)) extraInfo.push(`Started ${relativeTime(match.startTime)}`)
    else if (MatchTools.isReady(tournament, match)) extraInfo.push("Ready to start")
    else extraInfo.push("Not ready")
    if (match.venue) extraInfo.push(match.venue.name)
    return extraInfo.join(", ")
  }
  static icon(tournament, match) {
    return MatchTools.isCompleted(match)
      ? "star"
      : MatchTools.isInProgress(match)
      ? "star_half"
      : MatchTools.isReady(tournament, match)
      ? "star_border"
      : "pan_tool"
  }

  static venueOptions(tournament) {
    const result = [{ value: NA_VENUE, display: NA_VENUE }]
    const v = tournament.venuesToUse
    if (v) {
      return result.concat(
        v
          .filter(x => x.isActive && !x.reservedBy)
          .sort((a, b) => (a.name < b.name ? -1 : b.name < a.name ? 1 : 0))
          .map(x => {
            return { value: x.id, display: x.name }
          })
      )
    }
    return result
  }

  static competitorOptions(tournament) {
    return tournament.competitors.map(x => {
      return { value: x.id, display: x.name }
    })
  }
}
//#endregion

//#region Competitor
/*
export class CompetitorTools {
  static isReady(comp) {
  }
}
*/
//#endregion

//#region Dialogs
export const DialogInputTypes = {
  text: "text",
  number: "number",
  bool: "checkbox",
  email: "email",
  pw: "password",
  date: "date",
  datetime: "datetime-local"
}

export class DialogInput {
  label = ""
  hint = ""
  value = ""
  type = DialogInputTypes.text
  options = []
  required = false
  multiline = false
  disabled = false
}
//#endregion



// WEBPACK FOOTER //
// ./src/js/helper.js